import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

const Banner1 = ({ heading1 = (
  <span className="text-primary">
    Innovative Automation, Engineered for Excellence
  </span>
) }) => {
  return (
    <div className="py-5">
      <Container fluid className="text-center">
        <Row className="justify-content-center">
          <Col md={8}>
            <animate-on-reveal
              animation="pulse"
              duration="300ms"
              delay="0s"
              direction="normal"
              easing="ease"
              iteration="1"
            >
              <h2 className="fw-bold">
                {heading1}
              </h2>
            </animate-on-reveal>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Banner1.propTypes = {
  heading1: PropTypes.element,
};

export default Banner1;
